export default {"src":"/_next/static/media/soc-2.6a280b3c.svg","height":390,"width":391,"blurWidth":0,"blurHeight":0};